export  default [
    {
        path: "/setting",
        name: "setting",
        component: () => import("./index"),
        meta: {
            title: "系统设置"
        }
    },

]